import React from "react";
import styles from "./SiteSearchResult.module.scss";
import { SiteSearchType } from "types";
import Text from "components/text/Text";
import { getPageByObjectType } from "helpers";
import { Highlight } from "react-instantsearch";
//import { Snippet } from "react-instantsearch";


export const SiteSearchResult = ({ hit }: { hit: SiteSearchType }) => {
  const onNavigate = (hit: SiteSearchType) => {
    if (!hit.url) return;
    else {
      const { url } = hit;
      window.open(getPageByObjectType(hit.objectType, hit.hasMultiple) + url, "_self");
    }
  }



  return (
    <div className={styles.hitSiteSearch} onClick={() => onNavigate(hit)}>
      <Text className={styles.textTitle} text={`${hit.title}`} useHighLight><Highlight attribute="title" hit={hit}/></Text>
      {hit.breadCrumbs && <p className={styles.textPurple}>{hit.breadCrumbs}</p>}
      {/* <Snippet className={styles.textBody} attribute="body" hit={hit} /> */}
      <Text className={styles.textBody} text={`${hit.description}`} useHighLight><Highlight attribute="description" hit={hit} /></Text>
      {/* {hit.body && <Text className={styles.textBody} text={`${hit.body}`} useHighLight><Highlight attribute="body" hit={hit} /></Text>} */}
    </div>
  );
};
